import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./Header";
import Footer from "./Footer";
import "./Case.css";

const CaseStudies = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Header />
            {/* <!-- no header, just hero with floating badge --> */}
            <section className="case-hero">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="content-container">
                    <div className="hero-content">
                        <div className="identifier-mini" data-aos="fade-down">
                            <i className="fa-regular fa-briefcase"></i> CASE STUDIES · O'HANLON INNOVATION IN ACTION
                        </div>
                        <h1 className="hero-title" data-aos="fade-up">Real patents, real<br />O'Hanlon difference</h1>
                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">From startup to Fortune 500 – how AI + attorney delivered speed and strength.</p>
                    </div>
                </div>
            </section>
            {/* <!-- main case studies container --> */}
            <div class="content-container">
                <div class="case-card-container" data-aos="fade-up">

                    {/* <!-- grid cases --> */}
                    <div class="case-grid">
                        {/* <!-- case 1 --> */}
                        <div class="case-card" data-aos="fade-up">
                            <div class="case-pic" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?w=600&auto=format&fit=crop')" }}>
                                <div class="case-tag">granted in 8 months</div>
                            </div>
                            <div class="case-content">
                                <h3>Nexus Medical</h3>
                                <div class="case-industry"><i class="fa-regular fa-hospital"></i> MedTech / diagnostic</div>
                                <div class="case-stats">
                                    <div class="stats"><span class="num">8</span> <span class="desc">months</span></div>
                                    <div class="stats"><span class="num">3</span> <span class="desc">office actions avoided</span></div>
                                    <div class="stats"><span class="num">100%</span> <span class="desc">claims allowed</span></div>
                                </div>
                                <p class="case-text">Startup with a novel biosensor. AI generated 80% draft in 2 days; O'Hanlon attorney refined claims to focus on unique signal processing. Result: notice of allowance without any prior art rejections.</p>
                                <a href="#" class="read-more">read full study <i class="fa-regular fa-arrow-right"></i></a>
                            </div>
                        </div>
                        {/* <!-- case 2 --> */}
                        <div class="case-card" data-aos="fade-up" data-aos-delay="100">
                            <div class="case-pic" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&auto=format&fit=crop')" }} >
                                <div class="case-tag">invalidated competitor</div>
                            </div>
                            <div class="case-content">
                                <h3>VoltEdge Energy</h3>
                                <div class="case-industry"><i class="fa-regular fa-bolt"></i> cleantech / battery</div>
                                <div class="case-stats">
                                    <div class="stats"><span class="num">$4.2M</span> <span class="desc">saved in licensing</span></div>
                                    <div class="stats"><span class="num">45</span> <span class="desc">days search</span></div>
                                </div>
                                <p class="case-text">Facing a patent infringement suit, VoltEdge used our O'Hanlon invalidity search ($2,500 pilot). Uncovered strong Japanese prior art; case dismissed with prejudice. ROI: millions.</p>
                                <a href="#" class="read-more">read full study <i class="fa-regular fa-arrow-right"></i></a>
                            </div>
                        </div>
                        {/* <!-- case 3 --> */}
                        <div class="case-card" data-aos="fade-up" data-aos-delay="200">
                            <div class="case-pic"
                                style={{ backgroundImage: "url('https://ambiq.com/wp-content/uploads/2023/08/drone-monitoring-a-forest-1200x800-1.jpg')" }}>
                                <div class="case-tag">pro → utility</div>
                            </div>
                            <div class="case-content">
                                <h3>AgriDrones Inc.</h3>
                                <div class="case-industry"><i class="fa-regular fa-leaf"></i> agtech / uav</div>
                                <div class="case-stats">
                                    <div class="stats"><span class="num">14</span> <span class="desc">days prov→nonprov</span></div>
                                    <div class="stats"><span class="num">2</span> <span class="desc">continuations</span></div>
                                </div>
                                <p class="case-text">Used AI to draft provisional in one afternoon. After 11 months, O'Hanlon attorney converted to non‑provisional with expanded claims covering swarming tech. Now portfolio licensed to major agri‑player.</p>
                                <a href="#" class="read-more">read full study <i class="fa-regular fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>

                    {/* <!-- featured deep dive --> */}
                    <div class="featured-case" data-aos="zoom-in">
                        <span style={{ background: "#1D3A90", color: "white", padding: "0.2rem 1rem", borderRadius: "30px", fontSize: "0.8rem" }}>featured: biotech</span>
                        <h2 style={{ margin: "1rem 0 0.5rem" }}>GenOmni – 12 patents, one unified strategy</h2>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem", alignItems: "center" }}>
                            <div style={{ flex: "2" }}>
                                <p><i class="fa-regular fa-dna" style={{ color: "#1D3A90" }}></i> <strong>Challenge:</strong> CRISPR‑based startup needed broad protection for delivery system, but faced crowded landscape.</p>
                                <p><strong>O'Hanlon approach:</strong> AI analyzed 2,000+ prior art documents; attorney crafted claims focusing on novel lipid formulation. Within 10 months, 12 utility applications filed (4 already allowed).</p>
                                <p><strong>Outcome:</strong> Series B led by top VC, citing "defensible patent estate."</p>
                                <a href="https://patentdefenseforce.com/use-cases" class="read-more">Download case study PDF <i class="fa-regular fa-file-pdf"></i></a>
                            </div>
                            <div style={{ flex: "1", background: "#0B1E4A", color: "white", borderRadius: "2rem", padding: "1.5rem", textAlign: "center" }}>
                                <div class="stats"><span class="num" style={{ color: "#54A6E9" }}>12</span> <span class="desc" style={{ color: "#ccc" }}>patents filed</span></div>
                                <div class="stats"><span class="num" style={{ color: "#54A6E9" }}>100%</span> <span class="desc" style={{ color: "#ccc" }}>allowance rate so far</span></div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- additional mini cases --> */}
                    <h2 style={{ margin: "3rem 0 1.5rem", color: "#0B1E4A" }}>More success stories</h2>
                    <div class="mini-case-grid">
                        <div class="mini-case-item"><i class="fa-regular fa-circle-check"></i> <strong>FinTech AI</strong> – software patent granted in 11 months, claims cover core payment algo.</div>
                        <div class="mini-case-item"><i class="fa-regular fa-circle-check"></i> <strong>Consumer electronics</strong> – design patent portfolio, enforced against copycat.</div>
                        <div class="mini-case-item"><i class="fa-regular fa-circle-check"></i> <strong>Chemical process</strong> – invalidity search saved $2.1M licensing demand.</div>
                    </div>

                    <hr style={{ margin: "3rem 0", border: "1px solid #e5cf5" }} />

                    <div style={{ textAlign: "center" }}>
                        <Link to={"/contact"} class="btn btn-primary"><i class="fa-regular fa-folder-open"></i> View all case studies</Link>
                    </div>
                </div>


            </div>
            <Footer />
        </>
    )
}

export default CaseStudies;